<template>
  <div class="row">
  	<div class="card col-12" style="width: 18rem;">
	  	<div class="card-body my-5 py-5">
	  		<div v-bind:class="loading">
		      <div class="d-flex justify-content-center">
		        <div class="spinner-border m-5" role="status">
		          <span class="sr-only">Loading...</span>
		        </div>
		      </div>
		    </div>
		    <div v-bind:class="result">
		  		<div class="row justify-content-center">
		  			<div class="col-12" v-if="!aceptar_instrucciones">
		  				<div class="row px-md-5 justify-content-center">
		  					<div class="col-12 text-center">
		  						<h3>¡Bienvenido!</h3>
		  					</div>
		  					<div class="col-md-8 mt-3 text-center">
		  						Estas a punto de iniciar tu proceso de registro para el ingreso a la facultad de psicología, pero antes de iniciar es importante que tomes los siguientes puntos:
		  					</div>
		  					<div class="col-md-10 mt-4">
		  						<ul>
		  							<li>
		  								Necesitaras tener disponible 4 horas de tiempo para llevar a cabo todo el proceso, ya que el registro esta cronometrado y en caso de que tardes más del tiempo señalado y se termine el tiempo, el sistema se cerrara, dejando inconcluso tu proceso, pudiendo llegar a afectar esta situación a tu evaluación.
		  							</li>
		  							<li>
		  								Necesitaras tener a la mano tu hoja de registro, así como el comprobante de pago de examen psicométrico, ya que con los folios de dichos documentos serán las contraseñas para que te puedas registrar.
		  							</li>
		  							<li>
		  								Debes de tener a la mano 2 hojas de maquina ya que se trabajará con ellas. (más delante se te dirá que harás con ellas).
		  							</li>
		  							<li>
		  								Un lápiz.
		  							</li>
		  							<li>
		  								Y un celular con el que puedas tomar fotos.
		  							</li>
		  						</ul>
		  					</div>
		  					<div class="col-md-8 mt-3 text-center">
		  						De faltarte alguno de los puntos antes mencionados, te recomendamos que no inicies tu proceso de registro, ya que como se te menciono dura cuatro horas, y si te falta algo, te faltara tiempo para responder las actividades que se te piden.
		  					</div>
		  					<div class="col-md-10 mt-3 text-center">
		  						Si tienes alguna duda o problema, puedes comunicarte con el equipo de soporte en nuestro Chat de Ayuda ubicado al inferior de la página.

		  					</div>
		  					<div class="col-md-10 text-center">
		  						El Chat de Ayuda solo estará disponible en un horario de 8am a 5pm.
		  					</div>
							<div class="col-12 mt-3 text-center">
								Gracias
							</div>
							<div class="col-12 text-center">
								Fapsi
							</div>
							<div class="col-12 mt-3 text-center">
								<button v-on:click="Aceptar_Instrucciones" class="btn btn-success">Iniciar</button>
							</div>
		  				</div>
		  			</div>
					<form v-if="aceptar_instrucciones" class="col-md-6 text-center" autocomplete="off" v-on:submit.prevent="Validar_Folio">
					    <h5 class="card-title">Presentar Exámen</h5>
					    <h6 class="card-subtitle mb-2 text-muted">Ingresa tus datos de pago</h6>
					    <div class="form-group mt-4">
						    <label for="idsolicitud">Folio de Registro</label>
						    <input type="text" v-model="idsolicitud" class="form-control w-50 mx-auto text-center" id="idsolicitud">
						</div>
						<div class="form-group">
						    <label for="folio_pago">No. Referencia de Pago</label>
						    <input type="text" v-model="folio_pago" class="form-control mx-auto text-center" id="folio_pago">
						    <small
						    	id="emailHelp"
						    	v-on:click="Mostrar_Ejemplo_Folio_Pago"
						    	class="form-text text-muted">¿Donde lo encuentro?</small>
						</div>
					    <button type="submit" class="btn btn-primary mt-4">Validar</button>
					</form>
		  		</div>
		  	</div>
	  	</div>
	</div>
	<div class="modal" id="modal_ejemplo_pago" tabindex="-1" role="dialog">
	  <div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header">
	        <h5 class="modal-title">Folio de Pago</h5>
	        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
	          <span aria-hidden="true">&times;</span>
	        </button>
	      </div>
	      <div class="modal-body">
	        <div class="row justify-content-center">
	        	<div class="col-lg-8 col-md-10 col-12 text-center">
	        		<img style="max-height:1000px;width:100%;" src="static/img/ejemplo_folio_pago.jpeg" alt="">
	        	</div>
	        </div>
	      </div>
	      <div class="modal-footer">
	        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
	      </div>
	    </div>
	  </div>
	</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      aceptar_instrucciones:false,
      idsolicitud:'',
      folio_pago:'',
    }
  },
  methods:{
  	Mostrar_Ejemplo_Folio_Pago(){
  		console.log('hola');
  		$('#modal_ejemplo_pago').modal();
  	},
  	Aceptar_Instrucciones(){
  		this.aceptar_instrucciones=true;
  	},
  	Validar(){
  		var pasar = true;
  		if (this.idsolicitud.length==0) {
  			pasar=false;
  			swal("Datos incompletos","El folio de registro es obligatorio", "error");
  		}else if (this.folio_pago.length==0) {
  			pasar=false;
  			swal("Datos incompletos","El folio_pago es obligatorio", "error");
  		}
  		return pasar;
  	},
  	Validar_Folio(){
  		if (!this.Validar()) {return;}
  		this.Cargando();
		this.$http.put('solicitudes/'+this.idsolicitud,{
			idsolicitud:this.idsolicitud,
			folio_pago:this.folio_pago
		})
		.then(respuesta=>{return respuesta.json()})
		.then(respuestaJson=>{
			if (respuestaJson.resp=='Excelente') {
				localStorage.apikeySiepsBiologicasUanl=JSON.stringify(respuestaJson.jwt);
			  	this.$router.push({name:'Datos_Alumno',params:{
			  		idsolicitud:respuestaJson.idsolicitud
			  	}});
			}else{
				this.Listo();
			  swal("¡Ups!",respuestaJson.resp, "error");
			}
		})
		.catch(error=>{
			this.Listo();
			swal("Favor de Intentar mas tarde", "Problemas para validar la información", "error");
		});
  	},
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	}
  },
  created(){
  	localStorage.apikeySiepsBiologicasUanl=JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaWVwc191YW5sX3Bvc2dyYWRvIiwiZGF0YSI6eyJpZHNvbGljaXR1ZCI6IjEiLCJpZGFsdW1ubyI6IjEifSwiaWF0IjoxNzE4ODM2MTM2LCJleHAiOjIwMzQzNjg5MzZ9.duBO5wP9M2_ttUAxXwcAIeIoxw0zom2Nlr0qX4RM7yg");
  }
};
</script>

<style scoped>
#emailHelp{
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Presentar.vue